export default function AppVersion() {
    return (
        <span className="float-end me-3 font-monospace">
            v2.6.6
        </span>
    );
}